import { Facebook, Github, Instagram, Twitter, Youtube } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="py-5 relative isolate overflow-hidden bg-[#fcf8f8]">
      <footer class="mt-10">
        <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
          <div class="mb-8 text-center ">
            <Link to="/" class="flex items-center justify-center">
              <img
                src={require("../../assets/logo/WePeWallet.png")}
                class="w-28 me-3"
                alt="FlowBite Logo"
              />
            </Link>
            <div className="py-6">
              <p className="text-[#6540b2] text-sm">
                With our crypto card and wallet app, the future of payments is
                already in your hands. Whether you’re a user seeking greater
                financial flexibility or a business ready to embrace modern
                commerce, our solution delivers value and innovation every step
                of.
              </p>
            </div>
          </div>

          <hr class="my-6 sm:mx-auto border-[#ececec] lg:my-8" />
          <div class="md:flex md:justify-between">
            <div>
              <h2 class="mb-6 text-md font-[600] text-[#6540b2] uppercase">
                Product
              </h2>
              <ul class="">
                <li class="mb-4">
                  <a
                    href="#Features"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Features
                  </a>
                </li>
                <li class="mb-4">
                  <a
                    href="#Features"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Integration
                  </a>
                </li>
                {/* <li class="mb-4">
                  <Link
                    to="/"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    FAQ
                  </Link>
                </li> */}
              </ul>
            </div>
            <div>
              <h2 class="mb-6 text-md font-[600] text-[#6540b2] uppercase">
                Company
              </h2>
              <ul class="">
                <li class="mb-4">
                  <Link
                    to="https://thinker-technology.com/about.php"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    About US
                  </Link>
                </li>
                <li class="mb-4">
                  <Link
                    to="https://thinker-technology.com/blog.php"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Blog
                  </Link>
                </li>
                <li class="mb-4">
                  <Link
                    to="https://thinker-technology.com/career.php"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Careers
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 class="mb-6 text-md font-[600] text-[#6540b2] uppercase">
                Resources
              </h2>
              <ul class="">
                <li class="mb-4">
                  <a
                    href="#Features"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Community
                  </a>
                </li>
                {/* <li class="mb-4">
                  <Link
                    to="/"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Docs
                  </Link>
                </li> */}
                <li class="mb-4">
                  <a
                    href="#Contact"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 class="mb-6 text-md font-[600] text-[#6540b2] uppercase">
                HELP & SUPPORT
              </h2>
              <ul class="">
                <li class="mb-4">
                  <Link
                    to="/privacy-policy"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Privacy
                  </Link>
                </li>
                <li class="mb-4">
                  <Link
                    to="/terms"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Terms
                  </Link>
                </li>
                {/* <li class="mb-4">
                  <Link
                    to="/"
                    class="hover:text-[#e83f3b] transition-all text-[#6540b2] font-normal no-underline"
                  >
                    Security
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>

          <div class="mt-10 ">
            <div class="flex my-4 sm:justify-center sm:mt-0 gap-1">
              <Link
                to="https://www.facebook.com/groups/thinkertechnology"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <Facebook className="w-6 h-6" />
              </Link>
              <Link
                to="https://www.instagram.com/thinkertechnology4/"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <Instagram className="w-6 h-6" />
              </Link>
              <Link
                to="https://www.youtube.com/@thinker-technology"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <Youtube className="w-6 h-6" />
              </Link>
              <Link
                to="https://discord.com/"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <svg
                  class="w-6 h-6"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 21 16"
                >
                  <path d="M16.942 1.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.585 11.585 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3A17.392 17.392 0 0 0 .182 13.218a15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.63 10.63 0 0 1-1.706-.83c.143-.106.283-.217.418-.33a11.664 11.664 0 0 0 10.118 0c.137.113.277.224.418.33-.544.328-1.116.606-1.71.832a12.52 12.52 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM6.678 10.813a1.941 1.941 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z" />
                </svg>
              </Link>
              <Link
                to="https://x.com/ThinkerTechnol3"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <Twitter className="w-6 h-6" />
              </Link>
              <Link
                to="https://github.com/"
                target="_blank"
                class="text-[#fb6a2b] hover:text-[#e83f3b] transition-all hover:-mt-2 bg-[#ffedfd] hover:bg-[#fff] w-10 h-10 flex items-center justify-center rounded-lg"
              >
                <Github className="w-6 h-6" />
              </Link>
            </div>
            <div class="text-sm text-[#6540b2] text-center">
              Copyright © 2024{" "}
              <Link
                to="/"
                class="text-[#e83f3b] transition-all font-medium mx-1"
              >
                {" "}
                WePe Pvt. Ltd.{" "}
              </Link>{" "}
              . All Rights Reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
